import Component from '../core/Component';

export default class AnimateText extends Component {

    constructor(element) {
        super(element);

        let defaults = {
            onLoad: true,
        };


        this.options = {
            ...defaults,
            ...this.options
        };

        this.animate = this.animate;
    }

    require = async function() {
        this.element.style.opacity = 0;
        const TimelineLite = await import('TimelineLite');
        await import('CSSPlugin');
        await import('EasePack');
        await import('SplitText');
        return TimelineLite
    }

    prepare(TimelineLite) {
        this.tl = new TimelineLite,
            this.text = new SplitText(this.element, {type:"chars,lines"}),
            this.chars = this.text.chars; //an array of all the divs that wrap each character

        //this.reset();

        if (this.options.onLoad) {
            this.animate();
        }
    }

    animate() {
        this.tl = new TimelineLite;
        this.element.classList.add('is-displayed');
        setTimeout(() => {
            this.tl.staggerFrom(this.chars, 1, {
                y: 40,
                opacity: 0,
                delay: 0,
                force3D: true,
                ease: Back.easeOut.config(1.4),
            }, 0.03, 0);
            this.tl.play();
            this.element.style.opacity = 1;
        })
    }

    reset() {
        this.element.classList.remove('is-displayed');
        this.element.style.opacity = 0;
    }

}


// WEBPACK FOOTER //
// ./components/AnimateText.js